import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useBlocker } from "@organizacaox/lai-design-system/router";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@organizacaox/lai-design-system";
import { getCallPresence } from "./call-presence.js";
import { useCallPresence } from "./use-unload-guard.js";

export function DialerNavigationGuard() {
  const { t } = useTranslation();
  const { available } = useCallPresence();
  const blocker = useBlocker({
    shouldBlockFn: ({ current, next }) =>
      getCallPresence().available && current.pathname !== next.pathname,
    disabled: !available,
    // O UnloadGuard já cuida de recarregar/fechar a aba.
    enableBeforeUnload: false,
    withResolver: true,
  });
  const reset = blocker.reset;

  useEffect(() => {
    if (!available) reset?.();
  }, [available, reset]);

  return (
    <AlertDialog
      open={available && blocker.status === "blocked"}
      onOpenChange={(open) => {
        if (!open) reset?.();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("calling.dialer.navigationGuard.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("calling.dialer.navigationGuard.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("calling.dialer.navigationGuard.stay")}</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
